import React, { Component } from "react"
import { connect } from 'react-redux';
import Service from '../../../services';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import { BasicLazyParams, getServerTime } from '../../../utile';
import Authentication from './../../session';
import Authorizer, { PERMISSIONS } from '../../session/authorizer';
import _ from 'lodash';
import { MailIcon } from '../../svgIcons';
import LoadingComponent from '../../loadingComponent';
import { baseUrlAdmin } from '../../../store/apiConstants';
import withRouter from '../../lib/withRouter';
import moment from 'moment-timezone';
import './styles.scss'
import ClassetCalendar from "../../../classetComponents/classetCalender";
import BranchToSectionDDPreFill from "../../BaseDropdownComponents/BranchToSectionDDPreFill";
import { RadioButton } from "primereact/radiobutton";
import { Checkbox } from "primereact/checkbox";
import ClassetStudentSearchFilter from "../../Search/ClassetStudentSearchFilter";

let morning = true;
let afternoon = true;
let attendanceState = 'P';

class StudentAttendance extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            groups: [],
            curriculumInfo: {},
            isShowBoardCreate: false,
            editBoardData: null,
            isBoardAdd: true,
            isShowBoards: true,
            isShowClasses: false,
            editChapterData: null,
            isShowExportToOffline: false,
            globalSearch: '',
            attendance: [],
            lazyParams: BasicLazyParams,
            totalRecords: 0,
            date: moment().tz('Asia/Kolkata').format('YYYY-MM-DD'),
            dropdownsData: {},
            morning: true,
            afternoon: true,
            blockedDates: [],
            isBlockedDatesLoading: false,
            hasDropdownsSelected: false,
            overrideBlocking: false,
            hasUserInteracted: false,
        };
        this.service = new Service();

    }

    componentDidMount() {

    }


    onPage = (event) => {

        this.setState((prevState) => {

            return {
                lazyParams: {
                    ...prevState.lazyParams,
                    ...event
                }
            };
        }, this.getStudentsAttendance);
    }

    onSort = (event) => {

        this.setState((prevState) => {

            return {
                lazyParams: {
                    ...prevState.lazyParams,
                    ...event
                }
            };
        }, this.getStudentsAttendance);
    }

    onFilter = (event) => {

        event['first'] = 0;
        this.setState((prevState) => {

            return {
                lazyParams: {
                    ...prevState.lazyParams,
                    filters: event.filters
                }
            };
        }, this.getStudentsAttendance);
    }

    setDropdownValues = (dropdownsData) => {
        this.setState({
            dropdownsData: dropdownsData,
            overrideBlocking: false,
            attendance: [],
            hasUserInteracted: true
        },
            () => {
                if (dropdownsData.branchId && dropdownsData.boardId && dropdownsData.classId && dropdownsData.sectionId) {
                    this.setState({ hasDropdownsSelected: true });
                    this.getBlockedDatesForAttendance(dropdownsData);
                    if (this.state.date) {
                        this.getStudentsAttendance(dropdownsData.sectionId, dropdownsData.selectedsectionName);
                    }
                } else {
                    this.setState({ hasDropdownsSelected: false, blockedDates: [] });
                }
            })
    }

    getBlockedDatesForAttendance = (dropdownsData) => {
        this.setState({ isBlockedDatesLoading: true });

        const academicYear = localStorage.getItem("userAcademicYear");
        const params = new URLSearchParams({
            academicYear,
            branchId: dropdownsData.branchId,
            boardId: dropdownsData.boardId,
            gradeId: dropdownsData.classId,
            sectionId: dropdownsData.sectionId
        });

        const url = `${baseUrlAdmin}/event-calender/blocked-dates-attendance?${params}`;

        this.service.get(url, true).then(res => {
            if (res && res.status && res.res && res.res.status && res.res.data) {
                const blockedDates = res.res.data.blockedDates || [];
                this.setState({
                    blockedDates: blockedDates,
                    isBlockedDatesLoading: false
                });

                if (blockedDates.length > 0) {
                    this.toast.show({
                        severity: 'info',
                        summary: 'Holidays Loaded',
                        detail: `${blockedDates.length} holidays/blocked dates found`,
                        life: 2000
                    });
                }
            } else {
                this.setState({
                    blockedDates: [],
                    isBlockedDatesLoading: false
                });
            }
        }).catch(e => {
            this.setState({
                blockedDates: [],
                isBlockedDatesLoading: false
            });
            console.error('[Attendance] Error fetching blocked dates:', e);

            this.toast.show({
                severity: 'warn',
                summary: 'Warning',
                detail: 'Could not load holiday information. Only Sundays will be blocked.',
                life: 4000
            });
        });
    }

    getStudentsAttendance = (sectionId, selectedsectionName) => {
        if (!this.state?.date) {
            return;
        }

        attendanceState = 'P';
        this.setState({
            isLoading: true,
            attendance: [],
        })
        const payload = {
            sectionId: sectionId,
            sectionName: selectedsectionName,
            date: this.state?.date,
            academicYear: localStorage.getItem("userAcademicYear"),
        };
        const url = `${baseUrlAdmin}/attendance/get?limit=100000&page=1`;
        this.service.post(url, payload, true).then(res => {

            if (res && res.status && res.res.status) {
                const defaultAttendance = res.res.data.map(student => ({
                    ...student,
                    attendanceState: student?.attendanceState ? student?.attendanceState : '',
                }));

                this.setState({
                    isLoading: false,
                    attendance: defaultAttendance,
                    totalRecords: res.res.totalRecords
                });
            } else {
                this.setState({
                    isLoading: false
                });
                this.toast.show({ severity: 'error', summary: 'Some error occured', detail: res.errMessage, life: 3000 });
            }
        }).catch(e => {
            this.setState({
                isLoading: false
            });
            console.log(e);
        })
    }
    saveAttendance = () => {
        if (!this.state.hasDropdownsSelected) {
            this.toast.show({
                severity: 'error',
                summary: 'Selection Required',
                detail: 'Please select branch, board, grade and section first',
                life: 3000
            });
            return;
        }

        if (this.state.isBlockedDatesLoading) {
            this.toast.show({
                severity: 'warn',
                summary: 'Please Wait',
                detail: 'Holiday information is still loading. Please wait...',
                life: 3000
            });
            return;
        }

        if (this.isCurrentDateBlocked()) {
            const reason = this.getBlockedDateReason(this.state.date);
            this.toast.show({
                severity: 'error',
                summary: 'Date Blocked',
                detail: `Cannot save attendance for ${reason.toLowerCase()}`,
                life: 3000
            });
            return;
        }

        let { attendance } = this.state;
        if (attendance && attendance.length) {
            this.setState({
                isLoading: true
            })
            let academicYear = localStorage.getItem("userAcademicYear")
            let payload = {
                branchId: this.state?.dropdownsData?.branchId,
                boardId: this.state?.dropdownsData?.boardId,
                classId: this.state?.dropdownsData?.classId,
                sectionId: this.state?.dropdownsData?.sectionId,
                sectionName: this.state?.dropdownsData?.selectedsectionName,
                academicYear: academicYear,
                date: this.state?.date,
                presentStudentsInfo: attendance
                    .filter(student => student.attendanceState === 'P')
                    .map(student => student.user_id,
                    ),
                studentsInfo: attendance
                    .filter(student => student.attendanceState === 'A' || student.attendanceState === 'HD')
                    .map(student => ({
                        user_id: student.user_id,
                        attendanceState: student.attendanceState,
                    })),
            }

            const url = `${baseUrlAdmin}/attendance/save`;
            this.service.post(url, payload, true).then(res => {

                if (res && res.status && res.res.status) {
                    this.setState({
                        isLoading: false,
                    });
                    this.toast.show({ severity: 'success', summary: 'Success', detail: 'Successfully saved.', life: 3000 });
                    attendanceState = 'NA'
                } else {
                    this.setState({
                        isLoading: false
                    });
                    this.toast.show({ severity: 'error', summary: 'Some error occured', detail: res.errMessage, life: 3000 });
                }
            }).catch(e => {
                this.setState({
                    isLoading: false
                });
                console.log(e);
            })

        } else {
            this.toast.show({ severity: 'error', summary: 'No Attendance', detail: 'No Attendance to save', life: 3000 });
        }
    }

    isSunday = (dateString) => {
        if (!dateString) return false;
        return moment.tz(dateString, 'YYYY-MM-DD', 'Asia/Kolkata').day() === 0;
    }

    isDateBlocked = (dateString) => {
        if (!dateString) return false;

        if (this.state.overrideBlocking) {
            return false;
        }

        const isHoliday = this.state.blockedDates.includes(dateString);
        const isSundayDate = this.isSunday(dateString);

        return isHoliday || isSundayDate;
    }

    isCurrentDateBlocked = () => {
        return this.isDateBlocked(this.state.date);
    }

    getBlockedDateReason = (dateString) => {
        if (!dateString) return '';

        const isHoliday = this.state.blockedDates.includes(dateString);
        const isSundayDate = this.isSunday(dateString);

        if (isHoliday && isSundayDate) {
            return 'Sunday (Holiday)';
        } else if (isHoliday) {
            return 'Holiday';
        } else if (isSundayDate) {
            return 'Sunday';
        }

        return '';
    }

    // Check if a date is Sunday (weekday 0)
    isSunday = (date) => {
        if (!date) return false;
        try {
            return new Date(date).getDay() === 0;
        } catch (error) {
            console.error('[Attendance] Error checking if date is Sunday:', error);
            return false;
        }
    }

    // Check if a date is blocked (Holiday/Event or Sunday)
    isDateBlocked = (date) => {
        if (!date) return false;
        
        // If override is enabled, don't block any dates
        if (this.state.overrideBlocking) {
            return false;
        }
        
        try {
            const dateString = moment(date).format('YYYY-MM-DD');
            const isHoliday = this.state.blockedDates.includes(dateString);
            const isSundayDate = this.isSunday(date);
            
            return isHoliday || isSundayDate;
        } catch (error) {
            console.error('[Attendance] Error checking if date is blocked:', error);
            return false;
        }
    }

    // Check if current selected date is blocked
    isCurrentDateBlocked = () => {
        return this.isDateBlocked(this.state.date);
    }

    // Get reason why date is blocked
    getBlockedDateReason = (date) => {
        if (!date) return '';
        
        const dateString = moment(date).format('YYYY-MM-DD');
        const isHoliday = this.state.blockedDates.includes(dateString);
        
        if (isHoliday && this.isSunday(date)) {
            return 'Sunday (Holiday)';
        } else if (isHoliday) {
            return 'Holiday';
        } else if (this.isSunday(date)) {
            return 'Sunday';
        }
        
        return '';
    }

    studentAttendance = (row, value, index) => {
        if (!this.state.hasDropdownsSelected) {
            this.toast.show({
                severity: 'warn',
                summary: 'Selection Required',
                detail: 'Please select branch, board, grade and section first',
                life: 3000
            });
            return;
        }

        if (this.state.isBlockedDatesLoading) {
            this.toast.show({
                severity: 'warn',
                summary: 'Please Wait',
                detail: 'Holiday information is still loading. Please wait...',
                life: 2000
            });
            return;
        }

        if (this.isCurrentDateBlocked()) {
            const reason = this.getBlockedDateReason(this.state.date);
            this.toast.show({
                severity: 'warn',
                summary: 'Date Blocked',
                detail: `Cannot mark attendance on ${reason.toLowerCase()}`,
                life: 3000
            });
            return;
        }

        attendanceState = value;

        if (this.state.attendance?.length) {
            const updatedStudentsInfo = this.state.attendance.map(each => {
                if (each.user === row.user) {
                    return {
                        ...each,
                        attendanceState: attendanceState
                    };
                }
                return each;
            });

            this.setState({
                attendance: updatedStudentsInfo
            });
        }
    };

    markAllAttendance = (value) => {
        if (!this.state.hasDropdownsSelected) {
            this.toast.show({
                severity: 'warn',
                summary: 'Selection Required',
                detail: 'Please select branch, board, grade and section first',
                life: 3000
            });
            return;
        }

        if (this.state.isBlockedDatesLoading) {
            this.toast.show({
                severity: 'warn',
                summary: 'Please Wait',
                detail: 'Holiday information is still loading. Please wait...',
                life: 2000
            });
            return;
        }

        if (this.isCurrentDateBlocked()) {
            const reason = this.getBlockedDateReason(this.state.date);
            this.toast.show({
                severity: 'warn',
                summary: 'Date Blocked',
                detail: `Cannot mark attendance on ${reason.toLowerCase()}`,
                life: 3000
            });
            return;
        }

        if (!this.state.attendance?.length) {
            this.toast.show({
                severity: 'warn',
                summary: 'No Students',
                detail: 'No students available to mark attendance',
                life: 3000
            });
            return;
        }

        attendanceState = value;

        const updatedStudentsInfo = this.state.attendance.map(student => ({
            ...student,
            attendanceState: value
        }));

        this.setState({
            attendance: updatedStudentsInfo
        });

        const statusLabel = value === 'P' ? 'Present' : value === 'A' ? 'Absent' : 'Half-Day';
        this.toast.show({
            severity: 'success',
            summary: 'Bulk Update',
            detail: `Marked all ${this.state.attendance.length} students as ${statusLabel}`,
            life: 3000
        });
    };

    render() {
        const header = (
            <div className="flex justify-content-between bg-white">
                <div className="flex">
                    {this.state.showSearch && <InputText placeholder="Search" className="ml-4  h-2rem w-15rem"
                        value={this.state.globalSearch}
                        onChange={this.onGlobalSearch} />}
                </div>


            </div>
        );

        return (
            <div>

                <BranchToSectionDDPreFill setValues={this.setDropdownValues} />
                {/* <div className="flex">
                    <div className="flex flex-column justify-content-center align-items-center mt-3">
                        <RadioButton
                            inputId="ingredient1"
                            onChange={(e) => this.handleSearchLevel(1)}
                            checked={this.state.searchLevel === 1}
                        />
                    </div>

                    <div>
                        <BranchToSectionDDPreFill
                            ref={this.studentSearchRef}
                            selectedValue={this.state.searchLevel}
                            setValues={this.setDropdownValues}
                        />


                    </div>
                </div> */}

                {/* <div style={{ marginLeft: '100px' }} className="flex justify-content-start align-items-center">
                        <span className="">OR</span>
                    </div> */}

                {/* <div className="flex mt-4">
                    <div className="flex flex-column justify-content-center align-items-center mt-3">
                        <RadioButton
                            inputId="ingredient2"
                            onChange={(e) => this.handleSearchLevel(2)}
                            checked={this.state.searchLevel === 2}
                        />
                    </div>

                    <div className="field ml-4">
                        <ClassetStudentSearchFilter
                            ref={this.studentSearchRef}
                            selectedValue={this.state.searchLevel}
                            setValues={this.setDropdownValues}
                        />
                    </div>
                </div> */}



                <div className="grid md:grid-cols-2 md:justify-content-between lg:grid-cols-3 mx-4">
                    <div className="col-span-1">
                        <div className="flex align-items-end gap-3">
                            <div className="flex-1">
                                <ClassetCalendar
                                    className='border-round-md add-vehicle-field-input text-2xl w-full'
                                    calendarMode={'single'}
                                    value={this.state.date ? moment.tz(this.state.date, 'YYYY-MM-DD', 'Asia/Kolkata').toDate() : null}
                                    onChange={(e) => {
                                        const dateString = e.value ? moment(e.value).tz('Asia/Kolkata').format('YYYY-MM-DD') : null;
                                        this.setState({ date: dateString }, () => {
                                            this.getStudentsAttendance(this.state?.dropdownsData?.sectionId, this.state?.dropdownsData?.selectedsectionName);
                                        });
                                    }}
                                    maxDate={moment().tz('Asia/Kolkata').toDate()}
                                    disabledDates={this.state.overrideBlocking ? [] : this.state.blockedDates.map(dateStr => moment.tz(dateStr, 'YYYY-MM-DD', 'Asia/Kolkata').toDate())}
                                    disabledDays={this.state.overrideBlocking ? [] : [0]}
                                    disabled={this.state.isBlockedDatesLoading}
                                    placeholder={this.state.isBlockedDatesLoading ? "Loading blocked dates..." : "Select Date"}
                                    label={"Select Date"}
                                />
                            </div>
                            <div className="flex align-items-center" style={{ marginBottom: '0.5rem' }}>
                                <Checkbox
                                    checked={this.state.overrideBlocking}
                                    onChange={(e) => this.setState({ overrideBlocking: e.checked })}
                                    className="mr-2"
                                    inputId="overrideToggle"
                                />
                                <label
                                    htmlFor="overrideToggle"
                                    className="text-sm font-medium cursor-pointer"
                                    style={{ color: this.state.overrideBlocking ? '#f59e0b' : '#6b7280' }}
                                    title={this.state.overrideBlocking ? 'Override active - can mark attendance on any date' : 'Enable to allow attendance on Sundays and holidays'}
                                >
                                    <i className="pi pi-shield mr-1"></i>
                                    Override Sundays & Holidays
                                </label>
                            </div>
                        </div>
                        {this.state.isBlockedDatesLoading && (
                            <small className="text-blue-500 mt-1 block">
                                <i className="pi pi-spin pi-spinner mr-2"></i>
                                Loading holidays and blocked dates...
                            </small>
                        )}
                    </div>
                    <div className="col-span-1">
                        <p className='add-vehicle-field-label'><span className='ma-required'></span></p>
                        {/* <Authorizer permId={PERMISSIONS.ATTENDANCE} > */}
                        <Button
                            className='formSaveButton'
                            onClick={this.saveAttendance}
                            disabled={
                                attendanceState === 'NA' ||
                                !this.state.hasDropdownsSelected ||
                                this.isCurrentDateBlocked() ||
                                this.state.isBlockedDatesLoading
                            }
                        >
                            <p className='formSaveButtonText'>Save</p>
                        </Button>
                        {/* </Authorizer> */}
                        {!this.state.hasDropdownsSelected && this.state.hasUserInteracted && (
                            <small className="p-error mt-2 block">
                                Please select branch, board, grade and section first
                            </small>
                        )}
                        {this.state.hasDropdownsSelected && this.state.isBlockedDatesLoading && (
                            <small className="p-info mt-2 block">
                                Loading holiday information...
                            </small>
                        )}
                        {this.state.hasDropdownsSelected && !this.state.isBlockedDatesLoading && !this.state.overrideBlocking && this.isCurrentDateBlocked() && (
                            <small className="p-error mt-2 block">
                                Cannot mark attendance on {this.getBlockedDateReason(this.state.date).toLowerCase()}
                            </small>
                        )}
                        {this.state.hasDropdownsSelected && !this.state.isBlockedDatesLoading && this.state.overrideBlocking && this.isCurrentDateBlocked() && (
                            <small className="p-warn mt-2 block">
                                <i className="pi pi-exclamation-triangle mr-2"></i>
                                Override enabled: Allowing attendance on {this.getBlockedDateReason(this.state.date).toLowerCase()}
                            </small>
                        )}
                    </div>
                </div>

                {this.state.date ? (
                    <div className="card datatable-crud-demo mt-5 mx-4">
                        {/* Bulk Attendance Actions */}
                        {this.state.attendance?.length > 0 && !this.isCurrentDateBlocked() && (
                            <div className="flex align-items-center gap-3 mb-3 p-3 surface-100 border-round">
                                <span className="font-semibold text-color-secondary mr-2">Bulk Actions:</span>
                                <Button
                                    label="Mark All Present"
                                    icon="pi pi-check-circle"
                                    className="p-button-success p-button-sm"
                                    onClick={() => this.markAllAttendance('P')}
                                    disabled={this.state.isBlockedDatesLoading}
                                />
                                <Button
                                    label="Mark All Absent"
                                    icon="pi pi-times-circle"
                                    className="p-button-danger p-button-sm"
                                    onClick={() => this.markAllAttendance('A')}
                                    disabled={this.state.isBlockedDatesLoading}
                                />
                                <Button
                                    label="Mark All Half-Day"
                                    icon="pi pi-clock"
                                    className="p-button-warning p-button-sm"
                                    onClick={() => this.markAllAttendance('HD')}
                                    disabled={this.state.isBlockedDatesLoading}
                                />
                                <span className="ml-auto text-sm text-color-secondary">
                                    {this.state.attendance.length} student(s)
                                </span>
                            </div>
                        )}

                        <DataTable ref={(el) => this.dt = el}
                            value={this.state.attendance}
                            paginator
                            //lazy
                            className="dataTableValuesText"
                            responsiveLayout="scroll"
                            showGridlines
                            columnResizeMode="expand"
                            resizableColumns
                            rows={5}
                            rowsPerPageOptions={[5, 10, 25, 50, 100]}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                            globalFilter={this.state.globalFilter}
                        >
                            <Column field="given_name" header="Student Name" sortable style={{ width: "15rem", height: "6rem" }} alignHeader={"center"} headerClassName="text-color-secondary" bodyClassName='text-center' />
                            <Column field="" header="Enrollment No" sortable style={{ width: "15rem", height: "6rem" }} alignHeader={"center"} headerClassName="text-color-secondary" bodyClassName='text-center' body={(rowData) => {
                                return <>{rowData?.username.slice(3)}</>

                            }} />
                            <Column field="branchName" header="Branch Name" sortable style={{ width: "15rem", height: "6rem" }} alignHeader={"center"} headerClassName="text-color-secondary" bodyClassName='text-center' />
                            <Column field="boardName" header="Board Name" sortable style={{ width: "15rem", height: "6rem" }} alignHeader={"center"} headerClassName="text-color-secondary" bodyClassName='text-center' />

                            <Column field="className - sectionName" header="Grade - Section" sortable style={{ width: "15rem", height: "6rem" }} alignHeader={"center"} headerClassName="text-color-secondary" bodyClassName='text-center'
                                body={(rowData, index) => {
                                    return (
                                        <>
                                            <div>
                                                {rowData.className}-{rowData.sectionName}
                                            </div>
                                        </>
                                    )


                                }}

                            />
                            <Column field="" header="Mark Attendance" sortable style={{ width: "20rem", height: "6rem" }} alignHeader={"center"} headerClassName="text-color-secondary" bodyClassName='text-center'


                                body={(rowData, index) => {
                                    const isBlocked = this.isCurrentDateBlocked();
                                    return (
                                        <>
                                            {isBlocked ? (
                                                <div className="text-center">
                                                    <i className="pi pi-ban text-red-500 text-2xl mb-2"></i>
                                                    <br />
                                                    <small className="text-red-500">
                                                        {this.getBlockedDateReason(this.state.date)}
                                                    </small>
                                                </div>
                                            ) : (
                                                <>
                                                    <Button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: (rowData.attendanceState === 'P') ? "#7CDD56" : '#D9D9D9',
                                                            border: 'none',
                                                            borderRadius: '50PX',
                                                            marginRight: '10PX',
                                                            width: '50px',
                                                            height: '50px',
                                                            color: '#000000'
                                                        }}
                                                        rounded
                                                        label="P"
                                                        onClick={() => { this.studentAttendance(rowData, 'P', index) }}
                                                    />
                                                    <Button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: (rowData.attendanceState === 'A') ? "#C63737" : '#D9D9D9',
                                                            border: 'none',
                                                            borderRadius: '50PX',
                                                            marginRight: '10PX',
                                                            width: '50px',
                                                            height: '50px',
                                                            color: '#000000'
                                                        }}
                                                        rounded
                                                        label="A"
                                                        onClick={() => { this.studentAttendance(rowData, 'A', index) }}
                                                    />
                                                    <Button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: (rowData.attendanceState === 'HD') ? "#FAB710" : '#D9D9D9',
                                                            border: 'none',
                                                            borderRadius: '50PX',
                                                            width: '50px',
                                                            height: '50px',
                                                            color: '#000000'
                                                        }}
                                                        rounded
                                                        label="HD"
                                                        onClick={() => { this.studentAttendance(rowData, 'HD', index) }}
                                                    />
                                                </>
                                            )}
                                        </>
                                    )
                                }}
                            />
                            <Column header="Phone Number" sortable style={{ width: "15rem", height: "6rem" }} alignHeader={"center"} headerClassName="text-color-secondary" bodyClassName='text-center' body={(rowData, index) => {
                                return (
                                    <>
                                        <div>
                                            {rowData.parentContactNo}
                                        </div>
                                    </>
                                )


                            }} />
                        </DataTable>
                        {this.state.isLoading && <LoadingComponent />}
                    </div >
                ) : (
                    <div className="card mt-5 mx-4 p-4 text-center">
                        <i className="pi pi-calendar text-4xl text-gray-400 mb-3"></i>
                        <p className="text-gray-600 text-lg">Please select a date to view attendance records</p>
                    </div>
                )}

                <Toast ref={(el) => this.toast = el} position="bottom-right" />
            </div>
        );
    }
}

const mapStatesToProps = (state) => ({


    isLoading: state.boardsData.isLoading,
    isUpdated: state.boardsData.isUpdated,
    boardsData: state.boardsData,
    updateError: state.boardsData.error,
    updateErrorMessage: state.boardsData.errorMessage,
    branches: state.branchDataLatest.branches,
    isBranchLoading: state.branchDataLatest.isLoading,
    branchLevels: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data.levels,
    branchData: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data.data,
});
export default connect(null, {})(Authentication(withRouter(StudentAttendance)));